import { Line } from '@mm/components';
import { AngleLeftLightIcon } from '@mm/icons';
import classnames from 'classnames';
import { range } from 'lodash';
import React from 'react';
import { colors } from '@mm/utils';
import './StepperComponent.scss';

type Props = {
  goBack?: () => void;
  size: number;
  activeStep: number;
  css?: {
    container?: string;
  };
  isTransparent?: boolean;
};

export const StepperComponent = (props: Props) => {
  const { goBack, size, activeStep, css, isTransparent } = props;
  const steps = range(size);

  const stepLabel = (index: number, isLastIndex: boolean) => {
    const isProcessed = index < activeStep - 1;
    const isActive = index === activeStep - 1;
    const stepClassname = classnames('stepper__step', {
      'stepper__step--processed': isProcessed,
      'stepper__step--active': isActive,
    });
    const lineClassName = classnames('stepper__step-line', {
      'stepper__step-line-processed': isProcessed,
    });
    return (
      <div className="stepper__step-wrapper" key={index}>
        <div key={index} className={stepClassname} />
        {!isLastIndex && <Line className={lineClassName} />}
      </div>
    );
  };

  return (
    <div
      className={classnames(css?.container, 'stepper', {
        'stepper--transparent': isTransparent,
      })}
    >
      {goBack && (
        <AngleLeftLightIcon
          onClick={goBack}
          color={colors.palePurple}
          className="stepper__angle-left-icon"
        />
      )}
      <div className="stepper_steps">
        {steps.map(step => stepLabel(step, step === steps.length - 1))}
      </div>
    </div>
  );
};
